import React from 'react'
import { Link } from 'react-router-dom'

const List = ({ users, match }) => {
  const rows = users.map(user => (
    <tr key={user.id}>
      <td>{user.login}</td>
      <td>{user.email}</td>
      <td>{user.team}</td>
      <td>
        <Link to={`${match.path}/${user.id}/reports`} className='btn btn-sm btn-primary' disabled={false}>Reports</Link>
        {user.team === 'Google Play' && <Link to={`${match.path}/${user.id}/old_reports`} className='btn btn-sm'>Legacy Reports (GP)</Link>}
      </td>
    </tr>
  ))

  return(
    <div className="table-responsive">
      <table className="table table-striped table-hover">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Team</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </table>
    </div>
  )
}

export default List


// WEBPACK FOOTER //
// ./src/manager/javascripts/components/Users/List.jsx